(function () {
  if (window.MFCardCartInitialized) return;
  window.MFCardCartInitialized = true;

  function getRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function getBuybox(element) {
    return element ? element.closest('[data-mf-card-buybox]') : null;
  }

  function getQuantityInput(element) {
    var buybox = getBuybox(element);
    return buybox ? buybox.querySelector('[data-mf-qty-input]') : null;
  }

  function getMaxQuantity(input) {
    if (!input) return 99;

    var max = parseInt(input.getAttribute('max'), 10);

    if (Number.isNaN(max) || max < 1) {
      max = 99;
    }

    return max;
  }

  function normalizeQuantity(input, nextValue) {
    if (!input) return 1;

    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = getMaxQuantity(input);
    var quantity = parseInt(nextValue, 10);

    if (Number.isNaN(quantity)) {
      quantity = min;
    }

    quantity = Math.max(min, Math.min(max, quantity));
    input.value = String(quantity);

    updateQuantityButtons(input);

    return quantity;
  }

  function updateQuantityButtons(input) {
    var buybox = getBuybox(input);

    if (!buybox || !input) return;

    var value = parseInt(input.value, 10) || 1;
    var max = getMaxQuantity(input);
    var minus = buybox.querySelector('[data-mf-qty-minus]');
    var plus = buybox.querySelector('[data-mf-qty-plus]');

    if (minus) {
      minus.disabled = value <= 1;
    }

    if (plus) {
      plus.disabled = value >= max;
    }
  }

  function refreshCartUI() {
    fetch(getRoot() + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var countSelectors = [
          '.cart-count-bubble',
          '[data-cart-count]',
          '[data-header-cart-count]',
          '.cart-count',
          '#cart-icon-bubble span'
        ];

        countSelectors.forEach(function (selector) {
          document.querySelectorAll(selector).forEach(function (element) {
            element.textContent = cart.item_count;
            element.classList.remove('hidden');
          });
        });

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('ajaxCart:updated', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function (error) {
        console.warn('[MasterForce] No se pudo refrescar el contador del carrito.', error);
      });
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    var input = getQuantityInput(button);
    var quantity = normalizeQuantity(input, input ? input.value : 1);

    if (!variantId || button.classList.contains('is-loading')) return;

    button.classList.remove('is-added');
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(quantity));

    fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('No se pudo agregar al carrito.');
        }

        return response.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        button.setAttribute('aria-busy', 'false');

        refreshCartUI();

        setTimeout(function () {
          button.classList.remove('is-added');
        }, 1300);
      })
      .catch(function (error) {
        button.classList.remove('is-loading');
        button.setAttribute('aria-busy', 'false');
        console.error('[MasterForce] Error al agregar producto:', error);
      });
  }

  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-mf-qty-minus]');
    var plus = event.target.closest('[data-mf-qty-plus]');
    var button = event.target.closest('[data-mf-card-add-to-cart]');

    if (minus) {
      event.preventDefault();
      event.stopPropagation();

      var minusInput = getQuantityInput(minus);
      var minusValue = parseInt(minusInput.value, 10) || 1;

      normalizeQuantity(minusInput, minusValue - 1);
      return;
    }

    if (plus) {
      event.preventDefault();
      event.stopPropagation();

      var plusInput = getQuantityInput(plus);
      var plusValue = parseInt(plusInput.value, 10) || 1;

      normalizeQuantity(plusInput, plusValue + 1);
      return;
    }

    if (button) {
      event.preventDefault();
      event.stopPropagation();

      addToCart(button);
    }
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-mf-qty-input]');

    if (!input) return;

    normalizeQuantity(input, input.value);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mf-qty-input]').forEach(function (input) {
      normalizeQuantity(input, input.value);
    });
  });
})();